<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          Enter number of months you want to check the TA has not been used for or updated their details in the system.
          <div style="float:right;">
            <v-button
              size="xl"
              color="secondary"
              :disabled="unusedTAUsers.rows.length <= 0 || processingReport"
              @click="exportReport($store.state.lastUsedTAReport.unusedForMonths)"
            >
              <v-icon type="download" />
              Export Report
            </v-button>
          </div>
        </div>
        <div
          class="col-md-12"
          style="display:flex; height: 3rem"
        >
          <v-fieldset
            :id="'reportInput'"
            v-model="unusedForMonths"
            type="number"
            class="col-md-3"
            style="margin-left: -5px; margin-right: 10px;"
            :placeholder="$store.state.lastUsedTAReport.unusedForMonths?$store.state.lastUsedTAReport.unusedForMonths:'Enter Months'"
            :is-required="true"
            @input="unusedForMonths_change"
          />
          <v-checkbox-list
            id="member-list"
            v-model="selectedReportOptions"
            :groups="options"
            :selected-group="selectedReportOptionsState"
            @change="()=>{}"
          />
          &nbsp;&nbsp;&nbsp;
          <v-button
            size="xl"
            color="primary"
            :disabled="unusedForMonths <= 0 || processingReport || selectedReportOptions.length == 0"
            @click="performRunReport"
          >
            <v-icon type="power" />
            Run Report
          </v-button>
        </div>
        <div
          v-if="unusedTAUsers.rows.length > 0"
          class="col-md-12"
          style="display: flex; justify-content: space-between;"
        >
          <strong>
            TA(S) not used in last {{ $store.state.lastUsedTAReport.unusedForMonths }} months or not modified their personal details
          </strong>
          <v-button
            size="xl"
            color="primary"
            @click="sendNotification"
          >
            <v-icon type="notification" />
            Send Notification
          </v-button>
        </div>
        <div class="col-md-12">
          <v-table
            :table="unusedTAUsers"
            :show-row-count="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import PageTemplate from "@/templates/Page/index.vue";
  import {buildBreadCrumb, columnSort, columnFilter} from "@/common/tableFunctions"
  import Card from "@/molecules/Card";
  import Table from "@/molecules/Table";
  import Button from "@/atoms/Button";
  import Icon from "@/atoms/Icon";
  import Fieldset from "@/molecules/Fieldset";
  import CheckboxList from "@/molecules/CheckboxList";
  import {mapState} from "vuex";
  import {LAST_USED_TA_REPORT} from "../../store/actions.type";

  export default {
    name: "ReportsUnusedTA",
    components: {
      // "v-card": Card,
      "v-table": Table,
      "v-button": Button,
      "v-icon": Icon,
      "v-checkbox-list": CheckboxList,
      "v-fieldset": Fieldset
    },
    data: () => ({
      unusedForMonths: '',
      processingReport: false,
      searchKeyword: '',
      searchMode: false,
      selectedReportOptions: [],
      options: [{
        id: 'reviewed_at',
        selected: false,
        value: 'Profile Reviewed'
      },{
        id: 'last_used',
        selected: false,
        value: 'Last Used'
      }],
      unusedTAUsers: {
        columns: [
          {
            label: 'Name',
            field: 'name',
            sortFn: columnSort,
            thClass: 'sortable',
            link: true,
            filterOptions: {
              enabled: true,
              placeholder: 'User Name',
              filterFn: columnFilter
            },
          },
          {
            label: 'Email',
            field: 'emailObj',
            sortFn: columnSort,
            thClass: 'sortable',
            link: true,
            filterOptions: {
              enabled: true,
              placeholder: 'Email',
              filterFn: columnFilter
            },
          },
          {
            label: 'Last Used Date',
            field: 'last_used',
            sortFn: columnSort,
            thClass: 'sortable',
            hidden: true
          },
          {
            label: 'Reviewed At',
            field: 'reviewed_at',
            sortFn: columnSort,
            thClass: 'sortable',
            hidden: true
          }
        ],
        rows: [],
      },
    }),
    computed: {
      ...mapState({
        lastUsedTaReportUsers: state => state.lastUsedTAReport.lastUsedTaReportUsers,
        selectedReportOptionsState: state => state.lastUsedTAReport.selectedReportOptions
      })
    },
    mounted() {
      this.updateBreadCrumb();
      this.getUsers();
      this.selectedReportOptions = [...this.selectedReportOptionsState];
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['Reports'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      getUsers: function () {
        this.showHideSelectedColumns();
        this.unusedTAUsers.rows = this.lastUsedTaReportUsers;
      },
      exportReport: function(months) {
        let csv = 'First Name, Last Name, Email, Phone, Address, Suburb, State, Postcode, Country, Last Used At, Profile Reviewed At\n';
        this.unusedTAUsers.rows.forEach((row) => {
                csv += row.first_name+','+row.last_name+','+row.email+','+row.mobile_number+','+(''+row.address).replace(/,/gm,' ')+','+row.suburb+','+row.state+','+row.postcode+','+row.country+','+row.last_used.value+','+row.reviewed_at.value+',';
                csv += "\n";
        });

        const anchor = document.createElement('a');
        anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        anchor.target = '_blank';
        anchor.download = `Unused_TAs_${months}_Months.csv`;
        anchor.click();
      },
      performRunReport: function() {
        if(this.unusedForMonths <= 0) {
          return;
        }
        this.processingReport = true;
        this.$store.dispatch(LAST_USED_TA_REPORT, {unusedForMonths: this.unusedForMonths, selectedReportOptions: this.selectedReportOptions}).then((data) => {
          this.getUsers();
          this.processingReport = false;
        });
      },
      unusedForMonths_change: function() {
        if(this.unusedForMonths > 0) {
          this.processingReport = false;
          return;
        }
        this.processingReport = true;
      },
      sendNotification: function() {
        this.$router.push('/admin/notifications');
      },
      showHideSelectedColumns: function() {
        this.options.forEach(ele => {
          this.isColumnToShow(ele.id);
        })
      },
      isColumnToShow: function(colType) {
        const res = this.selectedReportOptions.find(ele => ele.id === colType);
        const ele = this.unusedTAUsers.columns.find(ele => ele.field == colType)
        ele.hidden = res ? false : true;
      }
    }
  }
</script>

